import $ from 'jquery';
import 'js-cookie';

class AlertMessage {
    constructor() {
        this.alertTitle = $('.atx-alert-message__title');
        this.alertBody = $('.alert-message__body');
        this.events();
    }

    events() {
        this.alertTitle.on('click', this.alertTitleHandler.bind(this));
    }

    alertTitleHandler() {
        if (!this.alertBody.hasClass('in')) {
            Cookies.set('atx_alert_msg', 'hide', {expires: 1, path: '/'});
        }
    }

}

export default AlertMessage;
